import * as React from 'react';
import './dccomborow.css';
import {ComboInfo} from "../../fbobjects/ComboInfo";
import CircleGraphComponent from "../CircleGraphComponent/index";
import {Calculation, UIComboDamageInfo} from "../../fbobjects/calculation/Calculation";
import Player from "../../fbobjects/Player";
import ChampionWithHealthBarC from "../ChampionWithHealthBarC/index";
import RiotDB from "../../fbobjects/RiotDB";
import AbilityDisplayC from "../AbilityDisplayC/index";

interface DCComboRowProps{
    combo:ComboInfo;
    source:Player;
    target:Player;
    level:number;
}

export default class DCComboRow extends React.Component<DCComboRowProps,any> {

    props:DCComboRowProps;

    constructor(props:DCComboRowProps){
        super(props);
        this.props = props;
    }

    getComboAbilities(champName):any{
        let abilities = this.props.combo.abilities;
        let champIcons = RiotDB.getChampionIcons(champName);
        let abilityDisplay = [];
        if (!champIcons){
            return "NO COMBOS YET"
        }
        for (let i = 0; i < abilities.length; i++) {
            let ability = abilities[i];
            let abilityDamageInfo = Calculation.calculatePlayerAbilityDamage(this.props.source, this.props.target, ability, this.props.level);
            if (ability.key.indexOf("AA") != -1){
                abilityDisplay.push(<AbilityDisplayC key={i} ability={ability} hasImage={false} damageInfo={abilityDamageInfo}/>)
            }
            else if ("DM".indexOf(ability.key) != -1){

            }
            else{
                abilityDisplay.push(<AbilityDisplayC key={i} ability={ability} icon={champIcons[ability.key]} hasImage={true} damageInfo={abilityDamageInfo}/>)
            }
        }
        return abilityDisplay;
    }

    //TODO account for whether the player has learned the ability yet

    getComboCalculations():UIComboDamageInfo{
        return Calculation.calculatePlayerComboDamage(this.props.source, this.props.target, this.props.combo, this.props.level)
    }

    calculateNumber(type){
        return this.getComboCalculations()[type];
    }

    calculatePercentage(type){
        let percentOfType = Calculation.calculatePlayerComboDamage(this.props.source, this.props.target, this.props.combo, this.props.level)[type];
        if (percentOfType > 1){
            percentOfType = 1;
        }
        return percentOfType;
    }


    render(){
        return(
            <div className="combo-row">
                <div className="combo-type">
                    <div className="champion-preview">
                        <ChampionWithHealthBarC
                            champName={this.props.target.selectedChampion}
                            damage={this.calculateNumber("damageNumber")}
                            target={this.props.target}
                            percent={this.calculatePercentage("percentHealth")}
                            ownerColor={'red'}
                            level={this.props.level}/>
                    </div>
                </div>
                <div className="combo-data-container">
                    <div className="combo-abilities-container">
                        <div className="combo-abilities">
                            {this.getComboAbilities(this.props.source.selectedChampion)}
                        </div>
                    </div>
                    <div className="combo-preview-container">
                        {/* TODO: change the input here based on selected champ*/}
                        {<CircleGraphComponent percent={this.calculatePercentage("percentHealth")} type={"damage"}/>}
                        <div className="combo-stats">
                            <div className="damage-to-enemy-text">
                                {`Damage To ${this.props.target.selectedChampion}`}
                            </div>
                            <div className="damage-to-enemy">
                                {this.calculateNumber("damageNumber").toFixed(0)}
                            </div>
                        </div>
                        <div className="divider"/>
                        <CircleGraphComponent percent={this.calculatePercentage("percentMana")} type={"mana"}/>
                        <div className="combo-stats">
                            <div className="damage-to-enemy-text">
                                {"Mana Cost"}
                            </div>
                            <div className="damage-to-enemy">
                                {this.calculateNumber("manaSpent")}
                            </div>
                        </div>
                        <div className="combo-preview">
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/DCComboRow/index.tsx